var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"test-vue"},[_c('svg',{attrs:{"width":_vm.radius,"height":_vm.radius,"viewBox":"-100 -100 200 200","version":"1.1","xmlns":"http://www.w3.org/2000/svg"}},_vm._l((_vm.circleR),function(item,index){return _c('circle',{class:'roateCircle ' + index,attrs:{"fill":"#F29123","cx":"0","cy":"-50","r":item}})}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17adbacb","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/common/load-img/load-img.vue
// module id = null
// module chunks = 